import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const accelareaderApi = createApi({
  reducerPath: "accelareaderApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getAccelareader", "getAccelareaderById"],
  endpoints: (builder) => ({
    getAccelareader: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getAccelareader"],
    }),
    getAccelareaderById: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getAccelareaderById"],
    }),

    createAccelareader: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["getAccelareader"],
    }),

    updateAccelareader: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
        };
      },
      invalidatesTags: ["getAccelareaderById"],
    }),
  }),
});

export const {
  useCreateAccelareaderMutation,
  useGetAccelareaderQuery,
  useGetAccelareaderByIdQuery,
  useUpdateAccelareaderMutation,
} = accelareaderApi;
